import React from 'react';

// Shared "answered so far" progress strip: one box per question, filled green when answered.
// Used by the IELTS/TOEFL model-test takers (per module) and the regular quiz taker (per subject).
//   questions   – ordered array of question objects (need .question_id)
//   isAnswered  – (q) => boolean
//   numberByQid – optional map question_id -> display number (falls back to position)
//   style       – optional overrides merged into the container
function AnsweredTracker({ questions = [], isAnswered, numberByQid = {}, style = {} }) {
    if (!questions.length) return null;
    const answeredCount = questions.filter(isAnswered).length;
    return (
        <div style={{ background: '#fff', borderTop: '1px solid #e5e7eb', padding: '0.5rem 1.25rem', ...style }}>
            <div className="text-muted small text-center mb-1">Answered {answeredCount} / {questions.length}</div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, justifyContent: 'center' }}>
                {questions.map((q, i) => {
                    const no = numberByQid[q.question_id] || (i + 1);
                    const done = isAnswered(q);
                    return (
                        <span
                            key={q.question_id}
                            title={`Question ${no}${done ? ' — answered' : ' — not answered'}`}
                            style={{
                                minWidth: 26, height: 26, padding: '0 6px', borderRadius: 6,
                                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                fontSize: '0.78rem', fontWeight: 600,
                                border: `1px solid ${done ? '#16a34a' : '#d1d5db'}`,
                                background: done ? '#16a34a' : '#fff',
                                color: done ? '#fff' : '#6b7280',
                            }}
                        >{no}</span>
                    );
                })}
            </div>
        </div>
    );
}

export default AnsweredTracker;
